// Constants
import { SERVICE_DOMAINS } from '../constants/services';

// Utilities
import { request } from '../utilities/http';

// Services
export interface IGetUserByTagsRequest {
  params: { networkId: string };
  query: {
    ids: string;
  };
}
export interface IGetUserByTagsResponse {
  userId: string;
  firstName: string;
  lastName: string;
  photoUrl: string;
  lastLogin: string;
}
export function getUserByTags({
  params,
  query
}: IGetUserByTagsRequest): Promise<IGetUserByTagsResponse[]> {
  return request(
    `${SERVICE_DOMAINS.API}/v1/${params.networkId}/people.search`,
    {
      method: 'GET',
      query
    }
  );
}

export interface IPersonAddTagRequest {
  params: { networkId: string };
  query: { tagId: string; userId?: string };
}
export interface IPersonAddTagResponse {}
export function personAddTag({
  params,
  query
}: IPersonAddTagRequest): Promise<IPersonAddTagResponse> {
  return request(
    `${SERVICE_DOMAINS.API}/v1/${params.networkId}/people.tag.create`,
    {
      method: 'GET',
      query
    }
  );
}

export interface IPersonRemoveTagRequest {
  params: { networkId: string };
  query: { tagId: string; userId?: string };
}
export interface IPersonRemoveTagResponse {}
export function personRemoveTag({
  params,
  query
}: IPersonRemoveTagRequest): Promise<IPersonRemoveTagResponse> {
  return request(
    `${SERVICE_DOMAINS.API}/v1/${params.networkId}/people.tag.delete`,
    {
      method: 'GET',
      query
    }
  );
}

// export interface IGetUserTagsRequest {
//     params: { networkId: string };
//     query: { userId: string };
// }
//
// export interface IGetUserTagsResponse {
//     tagId: string;
//     pathName: string;
// }
//
// export function getPersonTags({ query, params }: IGetUserTagsRequest): Promise<IGetUserTagsResponse[]> {
//     return request(`${SERVICE_DOMAINS.API}/v1/${params.networkId}/people.tag.list`, {
//         method: 'GET',
//         query
//     });
// }

// export interface IGetUserTagsRequest {
//     params: { networkId: string };
//     query: { userId: string };
// }
//
// export interface IGetUserTagsResponse {
//     tagId: string;
//     pathName: string;
// }
//
// export function getPersonTags({ query, params }: IGetUserTagsRequest): Promise<IGetUserTagsResponse[]> {
//     return request(`${SERVICE_DOMAINS.API}/v1/${params.networkId}/people.tag.list`, {
//         method: 'GET',
//         query
//     });
// }

export interface IGetUserQuestionsRequest {
  params: { networkId: string };
  query: { userId: string };
}

export interface IGetUserQuestionsResponse {
  questionId: string;
  created: string;
  description: string;
  answer: string;
}

export function getUserQuestions({
  query,
  params
}: IGetUserQuestionsRequest): Promise<IGetUserQuestionsResponse[]> {
  return request(
    `${SERVICE_DOMAINS.API}/v1/${params.networkId}/people.questions.list`,
    {
      method: 'GET',
      query
    }
  );
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/relation.ts